import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}

import {ref} from "@vue/runtime-core"
import {ArtistModel} from "@/types/ArtistModel";
import store from "@/store/index.js"
import axios from "axios";
import Profile from "@/components/Profile.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileArtist',
  setup(__props) {

const artist = ref<ArtistModel | null>()

axios.get('/api/profile/',
    {headers: {Authorization: `Bearer ${store.state.token}`}}
).then(
    response => {
      artist.value = response.data
      store.commit("setPhotoUrl", response.data.photo_url)
    }).catch(
    error => console.log(error)
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (artist.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Profile, {
            artist: artist.value,
            editable: true
          }, null, 8, ["artist"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})